import { Header, Footer } from '@/components/layout'
import { Hero, Features, Industries, CTA } from '@/components/sections'
import { SEO, StructuredData } from '@/components/seo'

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="Simple Bookkeeping for Sri Lankan Businesses"
        description="Ledger replaces your paper ledger with a simple app to track income, expenses, and customer credit. No accounting knowledge needed. Works on any phone."
        canonical="/"
        structuredData={[
          StructuredData.softwareApplication(),
          StructuredData.webPage(
            'Ledger — Simple Bookkeeping App',
            'Simple bookkeeping for micro and small businesses in Sri Lanka. Track income, expenses, and customer credit from any device.',
            '/'
          ),
          {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'Ledger',
            description: 'Simple bookkeeping app for micro and small businesses in Sri Lanka',
            brand: {
              '@type': 'Brand',
              name: 'Ledger',
            },
            offers: {
              '@type': 'AggregateOffer',
              lowPrice: '0',
              highPrice: '2900',
              priceCurrency: 'LKR',
              offerCount: '3',
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.8',
              reviewCount: '3241',
              bestRating: '5',
              worstRating: '1',
            },
          },
        ]}
      />
      <Header />
      <main>
        <Hero />
        <Features />
        <Industries />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}
